export { customWidgetTypeHandler } from "./CustomPLWidgetRenderer";
